export const NewError = 'NewError'
export const newError = (messageId, correlationId) => error => ({ type: NewError, error, messageId, correlationId })
